import { useState, useEffect, useContext, createContext } from 'react';
import { useAuth } from './useAuth';

const ALL_CLUBS = [
  { id: 'WA',  name: 'West Allis' },
  { id: 'MF',  name: 'Menomonee Falls' },
  { id: 'GB',  name: 'Green Bay' },
  { id: 'DEN', name: 'Denton' },
  { id: 'LEW', name: 'Lewisville' },
  { id: 'MCK', name: 'McKinney' },
];

const ClubContext = createContext(null);

export function ClubProvider({ children }) {
  const { clubs, hasAllClubs, isAdmin } = useAuth();

  const availableClubs = hasAllClubs
    ? ALL_CLUBS
    : ALL_CLUBS.filter(c => clubs.includes(c.id));

  const [currentClub, setCurrentClub] = useState(() => {
    const saved = localStorage.getItem('coms_current_club');
    if (saved) {
      const match = availableClubs.find(c => c.id === saved);
      if (match) return match;
    }
    return availableClubs[0] ?? null;
  });

  useEffect(() => {
    if (currentClub) {
      localStorage.setItem('coms_current_club', currentClub.id);
    }
  }, [currentClub]);

  const showClubSelector = isAdmin || availableClubs.length > 1;

  return (
    <ClubContext.Provider value={{ currentClub, setCurrentClub, availableClubs, showClubSelector }}>
      {children}
    </ClubContext.Provider>
  );
}

export function useClub() {
  const ctx = useContext(ClubContext);
  if (!ctx) throw new Error('useClub must be used within a ClubProvider');
  return ctx;
}